import styled from 'styled-components';
import { SecondaryButton } from './SecondaryButton';
import { rgba } from 'polished';
import { Colors } from '../../constants/colors';

export const CenteredButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 70px;

  > * {
    min-width: 280px;
  }

  ${SecondaryButton} {
    margin-top: 15px;

    :hover {
      background: ${rgba(Colors.primary, 0.05)};

      svg {
        transform: translateX(-5px);
      }
    }

    svg {
      margin: 0 15px 0 0;

      transform: none;
      transition: transform 0.2s ease-in-out;
    }
  }
`;
